// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"da431d3d","703":"674d2745"}[chunkId] + ".chunk.js";
};